// extracted by mini-css-extract-plugin
export var nofill = "percentageDonut-module--nofill--1bPYF";
export var fill = "percentageDonut-module--fill--20AiU";
export var container = "percentageDonut-module--container--2OOJw";
export var circleContainer = "percentageDonut-module--circleContainer--2LARK";
export var textContainer = "percentageDonut-module--textContainer--S7F7X";
export var value = "percentageDonut-module--value--2jq3y";
export var label = "percentageDonut-module--label--rrKIa";
export var circle = "percentageDonut-module--circle--KwLRH";